<template>
  <div>
    <p :class="{ 'description-text__bold': bold }">
      <span v-html="text"></span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      require: true,
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
p {
  color: #989898;
}

.description-text__bold {
  color: #333333;
  font-weight: 600;
  font-size: 21px;
  line-height: 1.23;
}
</style>
